import axios from "axios";
import { Message,MessageBox } from 'element-ui';
import router from "@/router";

const instance = axios.create({
    baseURL: "https://backend.xiaoesoft.top",
    timeout: 30000
});

instance.interceptors.request.use(config => {
    if (config.method !== 'get') {
        config.headers["Content-Type"] = 'application/x-www-form-urlencoded';
    }
    // config.headers["Content-Type"] = 'application/x-www-form-urlencoded';
    const token = localStorage.getItem("xbd-authorization-token")
    if (token && !config.url.endsWith("/login") && !config.url.endsWith("/captchaImage")) {
        config.headers["Authorization"] = "Bearer " + token
    }
    return config
}, err => {
    return Promise.reject(err)
})

instance.interceptors.response.use(res => {
    let res_data = res.data

    if (res_data.state != 0) {
        Message(res_data.error || '网络请求错误');

        if (res_data.state == 401 || res_data.state == 2) {
            // 删除token
            localStorage.removeItem("xbd-authorization-token")
            // 跳转登录页面
            router.push("/login").catch(err => {
                console.log(err);
            })
        } else if (res_data.state == 3) {
            // 批量续期，可能有部分用户名不存在，这里用来显示失败的
            MessageBox.alert(res_data.error_list.join('<br>'), '续期失败的', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true, // ⚠️ 必须开启！才会显示换行
                callback: action => {}
            });
        }

        return false
    }
    return res_data

}, err => {
    if (err.code === 'ECONNABORTED') {
        return 'timeout';
    }
    return Promise.reject(err)
})

export default instance